var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-message-container",
      class: { received: _vm.received },
      attrs: { id: "imageMessage" },
    },
    [
      _c(
        "div",
        {
          staticClass: "sc-message--text message-bubble",
          style: Object.assign({}, _vm.messageColors, {
            "background-color": _vm.messageColors.backgroundColor,
          }),
        },
        [
          _vm.isGroupMessage
            ? _c(
                "span",
                {
                  staticClass: "whatsapp-number-first",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.showWhatsappChatStarterModal = true
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      style: { color: _vm.getWhatsappNumberColor() },
                      attrs: { href: "javascript:void(0)" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.whatsappAuthorName) +
                          " - " +
                          _vm._s(_vm.whatsappAuthorNumber)
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.imageSrc()
            ? _c(
                "viewer",
                {
                  attrs: {
                    id: "imageViewer-" + _vm.getId(),
                    images: [_vm.imageSrc()],
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "cb-img-preview",
                      attrs: { content: _vm.$t("chatbotv2.imageView") },
                      on: {
                        click: _vm.show,
                        mouseenter: function ($event) {
                          _vm.hovered = true
                        },
                        mouseleave: function ($event) {
                          _vm.hovered = false
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass:
                          "img-thumbnail ant-upload-list-picture-card-container",
                        staticStyle: { "object-fit": "cover" },
                        attrs: {
                          id: "img-" + _vm.getId(),
                          src: _vm.imageSrc(),
                        },
                      }),
                      _vm._v(" "),
                      _vm.hovered
                        ? _c("md-icon", { staticClass: "cb-pr-icon" }, [
                            _vm._v(" visibility"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getCaption()
            ? _c("div", { staticClass: "caption-text" }, [
                _c("span", { staticClass: "sc-message--text-content" }, [
                  _vm._v(_vm._s(_vm.getCaption())),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isGroupMessage
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "end",
                    "align-items": "center",
                    padding: "0 0.3rem",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "sc-message-meta-new whatsapp-number",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.showWhatsappChatStarterModal = true
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          style: { color: _vm.getWhatsappNumberColor() },
                          attrs: { href: "javascript:void(0)" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.whatsappAuthorName) +
                              " - " +
                              _vm._s(_vm.whatsappAuthorNumber)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.whatsappAuthorNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-name": _vm.whatsappAuthorName,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }